import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Paper, Box, Chip, CircularProgress,
  Button, Divider,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'https://watchpassion.vercel.app/api';

const statusLabel = (s) => ({
  pending: 'In attesa', paid: 'Pagato', shipped: 'Spedito',
  cancelled: 'Annullato', ebay_redirect: 'eBay', bank_transfer: 'Bonifico in attesa',
}[s] || s);
const statusColor = (s) => ({ pending: 'warning', paid: 'success', shipped: 'info', cancelled: 'error' }[s] || 'default');
const methodLabel = (m) => ({ stripe: 'Carta', bank_transfer: 'Bonifico', ebay: 'eBay' }[m] || m);

export default function MyOrdersPage() {
  const { authHeader, user } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { navigate('/accedi', { state: { from: '/i-miei-ordini' } }); return; }
    axios.get(`${API}/orders/my`, { headers: authHeader() })
      .then(r => setOrders(r.data.orders || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [user]);

  if (loading) return <Container sx={{ pt: 6, textAlign: 'center' }}><CircularProgress /></Container>;

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>I miei ordini</Typography>

      {orders.length === 0 && (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary" gutterBottom>Nessun ordine trovato</Typography>
          <Button variant="contained" onClick={() => navigate('/mercato')}>Vai al marketplace</Button>
        </Paper>
      )}

      {orders.map(o => (
        <Paper key={o.id} sx={{ p: 3, mb: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
            <Box>
              <Typography fontWeight="bold">{o.item_title}</Typography>
              <Typography variant="caption" color="text.secondary">
                {new Date(o.created_at).toLocaleDateString('it-IT', { day: '2-digit', month: 'long', year: 'numeric' })}
              </Typography>
            </Box>
            <Chip label={statusLabel(o.payment_status)} color={statusColor(o.payment_status)} size="small" />
          </Box>
          <Divider sx={{ my: 1 }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography>Totale: <strong>€{(o.amount - (o.discount_amount || 0)).toFixed(2)}</strong></Typography>
              <Typography variant="body2" color="text.secondary">Pagamento: {methodLabel(o.payment_method)}</Typography>
              {o.payment_status === 'pending' && o.payment_method === 'bank_transfer' && (
                <Typography variant="body2" color="warning.main">
                  In attesa del bonifico — contattaci a Info@watchpassion.net
                </Typography>
              )}
            </Box>
            {o.item_url && (
              <Button size="small" href={o.item_url} target="_blank" endIcon={<OpenInNewIcon />}>
                Vedi su eBay
              </Button>
            )}
          </Box>
        </Paper>
      ))}
    </Container>
  );
}
